import { render, staticRenderFns } from "./PatientMedicalContents.vue?vue&type=template&id=6e99094f&scoped=true&"
import script from "./PatientMedicalContents.vue?vue&type=script&lang=js&"
export * from "./PatientMedicalContents.vue?vue&type=script&lang=js&"
import style0 from "./PatientMedicalContents.vue?vue&type=style&index=0&id=6e99094f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e99094f",
  null
  
)

export default component.exports